import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'm-confirmatin-pull-up',
    components: {},
})
export default class ConfirmationPullup extends Vue {

    // --------------------------------------------------------
    // Properties
    private isConfirmationPullup: boolean = false;

    @Prop()
    private userData: any;

    @Prop()
    private classData: any;

    @Prop()
    private classCode: any;

    // ----------------------------------------------------------------
    // Hooks

    // ------------------------------------------------------------------
    // Actions
    private onClosePopUp() {
        this.$emit('onClosePullup');
    }
    private onConfirmation() {
        this.$emit('onConfirm');
    }
    // ------------------------------------------------------------------------
    // Methods
}
